import React from 'react';
import Flow from '../flow';
import '../../../css/flow/config.less';
import { isNullOrUndefined } from 'util';

class Config extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            style: {
                transform: 'translateX(550px)',
            },
        };
    }

    componentDidMount() {
        setTimeout(() => this.setState({ style: null }));
    }

    render() {

        const flowName = this.props.flow;
        const inputs = this.props.inputs || [];

        if (this.props.manywhoTenantId && this.props.authenticationToken) {
            inputs.push({ 'Input TenantId': this.props.manywhoTenantId });
            inputs.push({ 'Input AuthenticationToken': this.props.authenticationToken });
        }

        return (
            <div className="config" style={this.state.style}>
                {
                    !isNullOrUndefined(flowName)
                        ? (
                            <Flow
                                tenantId={this.props.tenantId}
                                flowName={flowName}
                                inputs={this.props.inputs}
                                options={this.props.options}
                                component="main"
                                callbacks={this.props.callbacks}
                            />
                        )
                        : null
                }
                {
                    this.props.rootComponent && this.props.rootComponentProps
                        ? (
                            React.createElement(this.props.rootComponent, this.props.rootComponentProps)
                        )
                        : null
                }
            </div>
        );

    }

}

export default Config;
